export { default as confirmImg } from './confirm.json';
export { default as connectingImg } from './connecting.json';
export { default as errorImg } from './error.json';
export { default as failImg } from './fail.json';
export { default as signingImg } from './signing.json';
export { default as successImg } from './success.json';
export { default as pendingImg } from './pending.json';
export { default as walletImg } from './wallet.json';